import { NAME as APP_NAME, ROUTES as PARENT_ROUTES } from '../constants';

export const NAME = `${APP_NAME}/UN_SCHEDULE`;

export const REDUCER_NAME = 'unScheduleItinerary';

export const FORM_NAME = 'UnScheduleItinerary';

export const ENDPOINT_URL = `${OPERATIONS_EDGE}/api/fleets/management/unschedule`;
